import Vue from 'vue';
import Router from 'vue-router';
import Intro from '../views/intro/Intro';
import Page from '../views/page/Page';
import AccountCompaniesCountries from '../views/account/CompaniesCountries';
import Composition from '../views/composition/Composition';
import LoggedUser from '../views/account/LoggedUser';
import AccountDashboard from '../views/account/Dashboard';
import AdminManageMaterials from '../views/account/admin/materials/AdminManageMaterials';
import AdminManageApplications from '../views/account/admin/applications/AdminManageApplications';
import AdminManageCountries from '../views/account/admin/countries/ManageCountries';
import AdminManageCountriesShow from '../views/account/admin/countries/ShowCountry';
import AdminUsers from '../views/account/admin/users/AdminUsers';
import AdminPages from '../views/account/admin/pages/AdminPages';
import AdminConfiguration from '../views/account/admin/pages/AdminConfiguration';
// Lazy load AdminPagesEdit (big package used in this component - ckEditor)
const AdminPagesEdit = () => import('../views/account/admin/pages/AdminPagesEdit');
import UserCompositionList from '../views/composition/CompositionList';
import UserManageSubmissions from '../views/account/user/submissions/ManageSubmissions';
import AccountProfile from '../views/account/profile/AccountProfile';
import UserShowSubmission from '../views/account/user/submissions/ShowSubmission';

/**
 * MODULES
 */
import Auth from '@/views/auth/auth.routes';
import Applications from '../views/account/user/Applications/applications.routes';
import SubmitWaste from '../views/submit-waste/submit-waste.routes';

import store from '../store';
import DataDashboard from '../views/account/DataDashboard';

Vue.use(Router);

const guard = (_, __, next) => {
  if (store.getters['user/isLoggedIn']) {
    next();
  } else {
    next('/auth');
  }
};

export default new Router({
  base: '/',
  routes: [
    Auth,
    SubmitWaste,
    { path: '/intro', name: 'intro', component: Intro },
    { path: '/page/:pageId', name: 'page', component: Page },
    { path: '/companies-countries', name: 'create-account.companies-countries', component: AccountCompaniesCountries },
    {
      path: '/',
      component: LoggedUser,
      beforeEnter: guard,
      children: [
        { path: '', name: 'user.dashboard', component: AccountDashboard },
        { path: 'composition', name: 'user.composition', component: Composition },
        { path: 'compositions', name: 'user.composition-list', component: UserCompositionList },
        Applications,
        { path: 'submission', name: 'user.new-submission', component: UserShowSubmission },
        { path: 'submission/:id', name: 'user.show-submission', component: UserShowSubmission },
        { path: 'manage-submissions', name: 'user.manage-submissions', component: UserManageSubmissions },
        { path: 'manage-materials', name: 'user.manage-materials', component: AdminManageMaterials },
        { path: 'manage-countries', name: 'user.manage-countries', component: AdminManageCountries },
        { path: 'manage-countries/:code', name: 'user.manage-countries-show', component: AdminManageCountriesShow },
        { path: 'manage-countries/new', name: 'user.manage-countries-new', component: AdminManageCountriesShow },
        { path: 'manage-applications', name: 'user.manage-applications', component: AdminManageApplications },
        { path: 'manage-users', name: 'user.manage-users', component: AdminUsers },
        { path: 'manage-account', name: 'user.manage-account', component: AccountProfile },
        { path: 'pages', name: 'user.pages', component: AdminPages },
        { path: 'dashboard', name: 'user.data-dashboard', component: DataDashboard },
        { path: 'pages-configuration', name: 'user.pages.configuration', component: AdminConfiguration },
        { path: 'pages/:pageId', name: 'user.pages.edit', component: AdminPagesEdit },
      ]
    },
  ]
});
